import { Component, OnInit } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-grievance-redressal',
  templateUrl: './grievance-redressal.component.html',
  styleUrls: ['./grievance-redressal.component.scss']
})
export class GrievanceRedressalComponent implements OnInit {
  resValue:any;
  constructor(private util: UtilService) { }
  ngOnInit(): void {
    this.grievanceRedressalData();
  }
  goTohome() {
    this.util.route('home');
  }

  grievanceRedressalData(){
    this.resValue = this.util.config.find((data:any)=> data.name === 'GRIEVANCE').info;
  }


}
